var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{attrs:{"cols":"12"}},_vm._l((_vm.statistics),function(stat){return _c('nmt-sidebar-profile-stat',_vm._b({key:stat.name,staticClass:"py-1"},'nmt-sidebar-profile-stat',stat,false))}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }